import { Switch, Form, Typography } from 'antd'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ConfigCard } from './styles'

const FormItem = Form.Item
const Text = Typography.Text

const HasPreview = ({ initialHasPreview }) => {
	const [enabled, setEnabled] = useState(initialHasPreview ?? false)

	const handleChange = (checked) => {
		setEnabled(checked)
	}

	return (
		<ConfigCard
			title="Pré-visualizar documento"
			extra={
				<FormItem
					name="hasPreview"
					valuePropName="checked"
					initialValue={enabled}>
					<Switch checked={enabled} onChange={handleChange} />
				</FormItem>
			}>
			<Text>
				Quando esta opção estiver ativada, os usuários poderão visualizar uma
				prévia do documento na última página do formulário de cadastro.
			</Text>
		</ConfigCard>
	)
}

HasPreview.propTypes = {
	initialHasPreview: PropTypes.bool,
}

export default HasPreview
